import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    name: '',
    toggedIn: false
}

const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        login(state, action) {
            state.name = action.payload.name
            state.toggedIn = true
        }
    }
})

export const { login } = userSlice.actions
export default userSlice